import { Navigate, useLocation } from "react-router-dom";
import { canAccessRoute, getFirstAccessibleRoute } from "../core/common/adminPermissions";

type PermissionRouteProps = {
  children: React.ReactElement;
};

const PermissionRoute = ({ children }: PermissionRouteProps) => {
  const location = useLocation();

  if (!canAccessRoute(location.pathname)) {
    return <Navigate to={getFirstAccessibleRoute()} replace />;
  }

  return children;
};

export default PermissionRoute;
